define('OutSystems/ReactView/ErrorBoundary',["require", "exports", "tslib", "react"], function (require, exports, tslib_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ErrorBoundary = (function (_super) {
        tslib_1.__extends(ErrorBoundary, _super);
        function ErrorBoundary(props) {
            var _this = _super.call(this, props) || this;
            _this.state = { hasError: false };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function (_) {
            return { hasError: true };
        };
        ErrorBoundary.prototype.componentDidCatch = function (error, _) {
            var onError = this.props.onError;
            if (onError) {
                onError(error);
            }
        };
        ErrorBoundary.prototype.render = function () {
            var hasError = this.state.hasError;
            return hasError ? null : this.props.children;
        };
        return ErrorBoundary;
    }(React.Component));
    exports.default = ErrorBoundary;
});
//# sourceMappingURL=ErrorBoundary.js.map;
